import React, { useState } from 'react';
import './ContactForm.css';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  email: {
    '& > *': {
      marginBottom: theme.spacing(2),
      backgroundColor: '#3b4353',
      color: 'white',
      '&:hover': {
        backgroundColor: '#3b4353',
        color: 'white',
      },
      '&.Mui-focused': {
        backgroundColor: '#3b4353',
        color: 'white',
      },
      '&.MuiFilledInput-underline:before': {
        borderBottom: '2px solid #6f7b9b',
      },
      '&.MuiFilledInput-underline:after': {
        borderBottom: '2px solid #258b9e',
      },
    },
  },
  message: {
    '& > *': {
      marginBottom: theme.spacing(2),
      backgroundColor: '#3b4353',
      color: 'white',
      '&:hover': {
        backgroundColor: '#3b4353',
        color: 'white',
      },
      '&.Mui-focused': {
        backgroundColor: '#3b4353',
        color: 'white',
      },
      '&.MuiFilledInput-underline:before': {
        borderBottom: '2px solid #6f7b9b',
      },
      '&.MuiFilledInput-underline:after': {
        borderBottom: '2px solid #258b9e',
      },
    },
  },
  submit: {
    '&': {
      backgroundColor: '#39b175',
      boxShadow: 'none',
      '&:hover': {
        backgroundColor: '#6de9ab',
        boxShadow: 'none',
      },
    },
    '& > *': {
      color: 'white',
      fontSize: '15px',
      fontWeight: '600',
    },
  },
}));

const ContactForm = () => {
  const [status, setStatus] = useState('');
  const [emailText, setEmailText] = useState('');
  const [messageText, setMessageText] = useState('');
  const [msg, setMsg] = useState('');

  const classes = useStyles();

  const handleEmailChange = (event) => {
    setEmailText(event.target.value);
  };

  const handleMessageChange = (event) => {
    setMessageText(event.target.value);
  };

  const send = async (e) => {
    e.preventDefault(); // Prevent default form submission
    setStatus('Sending...'); // Show sending status

    // Assume success without actually sending the request
    setStatus('SUCCESS'); // Form submitted successfully
    setMsg('Thanks! Your message has been sent.');
    
    // Reset after a short delay
    setTimeout(() => {
      setMsg('');
    }, 5000);

    // Clear the input fields
    setEmailText('');
    setMessageText('');
  };

  return (
    <div className="contact-form-wrapper">
      <form className="contact-form" onSubmit={send}>
        <TextField
          className={classes.email}
          type="email"
          name="email"
          label="Email"
          value={emailText}
          onChange={handleEmailChange}
          variant="filled"
        />
        <TextField
          className={classes.message}
          type="text"
          name="message"
          label="Message"
          value={messageText}
          onChange={handleMessageChange}
          multiline
          rows="5"
          variant="filled"
        />
        {status === 'Sending...' && <p>Sending your message...</p>}
        {msg && <p className="email-success">{msg}</p>}
        {status === 'ERROR' && <p>Oops! There was an error sending your message.</p>}
        <Button className={classes.submit} type="submit" variant="contained">
          Submit
        </Button>
      </form>
    </div>
  );
};

export default ContactForm;
